import { render } from "./arki-project-object-component.vue?vue&type=template&id=27a1b164&scoped=true"
import script from "./arki-project-object-component.vue?vue&type=script&setup=true&lang=js"
export * from "./arki-project-object-component.vue?vue&type=script&setup=true&lang=js"

import "./arki-project-object-component.vue?vue&type=style&index=0&id=27a1b164&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a1b164"],['__file',"src/views/arki/views/request/project/arki-project-object-component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27a1b164"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27a1b164', __exports__)) {
    api.reload('27a1b164', __exports__)
  }
  
  module.hot.accept("./arki-project-object-component.vue?vue&type=template&id=27a1b164&scoped=true", () => {
    api.rerender('27a1b164', render)
  })

}


export default __exports__